<div class="wrapper">

    <app-next-lesson [class]="class" [lessonStart]="lessonStart"  [isTransferredLesson] ="isTransferredLesson" [isCurrent]="true" [data]="this.lesson" [practice] =true></app-next-lesson>
</div>
